import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import { getAccountById } from '../../actions/superadmin';
import AccountFormContainer from './AccountFormContainer';

export class EditAccountPage extends React.Component {
  static propTypes = {
    currAccount: PropTypes.object.isRequired,
    getAccountByIdAction: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    const { getAccountByIdAction, params: { accountId } } = this.props;
    const token = storeWithExpiration.get('token');
    if (accountId) getAccountByIdAction(accountId, token);
  };

  render() {
    const { currAccount, params: { accountId } } = this.props;
    // Only render if we have the current account
    const companyName = currAccount.get('companyName');
    const currAccountId = currAccount.get('id');
    if (companyName === '') return null;

    return currAccountId === parseInt(accountId, 10) ? (
      <div className="container form-only">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-block">
              <h2 className="card-title">Edit the {companyName} Account</h2>
              <p className="card-text">
                All fields are required.&nbsp;
                <em>Note: right now status and account type are hard-locked.</em>
              </p>
              <AccountFormContainer accountId={currAccountId} isEdit />
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  const { superadmin } = state;
  const currAccount = superadmin.get('currAccount');
  return { currAccount };
}

export default connect(mapStateToProps, {
  getAccountByIdAction: getAccountById,
})(EditAccountPage);
